export interface WhatsAppTemplateParamModel {
  id: string;
  index: string;
  field: string;
}
